import http from "@/tools/http";

class LoopService {
  setOrganizationUUID(organizationUUID) {
    this.organizationUUID = organizationUUID;
  }
  getAll(pagination) {
    return http.get(`/organizations/${this.organizationUUID}/loops`, { params: pagination });
  }
  create(loop) {
    return http.post(`/organizations/${this.organizationUUID}/loops`, loop);
  }
  update(loop) {
    return http.patch(`/organizations/${this.organizationUUID}/loops/${loop.uuid}`, loop);
  }
  getOne(loopId) {
    return http.get(`/organizations/${this.organizationUUID}/loops/${loopId}`);
  }
  countInteractions(loopUUID) {
    return http.get(`/organizations/${this.organizationUUID}/loops/${loopUUID}/auto`);
  }
  getIndicators(loopUUID, filters) {
    if (loopUUID) {
      return http.get(`/organizations/${this.organizationUUID}/loops/indicators/${loopUUID}`, { params: { static: filters } });
    }
    return http.get(`/organizations/${this.organizationUUID}/loops/indicators`);
  }
  updateLoopDealts(loopUUID) {
    return http.patch(`/organizations/${this.organizationUUID}/loops/${loopUUID}/auto`);
  }
}

export default LoopService;
